import { Params } from '@angular/router';

export interface QuickSearchResult {
  searchResultType: SearchResultType;
  quickSearchResponses: QuickSearchResponse[];
}

export enum SearchResultType {
  Organization = 'Organization',
  Department = 'Department',
  ChargingStationLocation = 'ChargingStationLocation',
  PricePolicy = 'PricePolicy',
  IdTag = 'IdTag',
  ChargingUser = 'ChargingUser',
}
export interface QuickSearchResponse {
  id: number | null;
  identifier: string | null;
  name: string;
  address: string | null;
  description: string | null;
  description2: string | null;
  updated: string;
  updatedBy: string | null;
  organizationId: number | null;
  departmentId: number | null;
  routerLink: string | null;
  queryParameters: Params;
  mapQueryParameters: Params;
  organizationName: string | null;
  departmentName: string | null;
  restricted: boolean | null;
}

export interface QuickSearchState {
  query: string;
  quickSearchResults: QuickSearchResult[];
  quickSearchQueryStrings: string[];
}

const gotoUrlTemplates = new Map<SearchResultType, routerLinkAndParameter>();
gotoUrlTemplates.set(SearchResultType.Organization, { routerLink: '/organizations', params: null });
gotoUrlTemplates.set(SearchResultType.Department, { routerLink: '/organizations', params: null });
gotoUrlTemplates.set(SearchResultType.ChargingStationLocation, { routerLink: '/locations', params: null });
gotoUrlTemplates.set(SearchResultType.PricePolicy, { routerLink: '/price-policies', params: null });
gotoUrlTemplates.set(SearchResultType.IdTag, { routerLink: '/id-tags', params: null });
gotoUrlTemplates.set(SearchResultType.ChargingUser, { routerLink: 'charging-users', params: null });

export default gotoUrlTemplates;

export interface routerLinkAndParameter {
  routerLink: string;
  params: Params | null;
}
